import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Select } from "antd";
import CardContainer from "../../commons/components/cardContainer"
import DataFieldList from "../../commons/components/dataFieldList";
import AccountSelect from "../../commons/components/AccountSelect"
import Utils from "../../commons/utils/utils"
import Http from "../../commons/utils/Http";
import Message from '../../commons/utils/message'
import Loading from "../../commons/components/loading";

import { setSelectedUser } from '../../store/actions/certificationActions';

import { LoadingDataUser } from "./styles"

function DataSearch(props) {
    const dispatch = useDispatch();
    const { selectedUser } = useSelector((state) => state.certification);

    const [userList, setUserList] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [PartnerList, setPartnerList] = useState([]);
    const [loading, setLoading] = useState(false);

    function formatSelectData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}                
                item.label = `${dataItem.first_name} ${dataItem.last_name} - ${Utils.maskCpf(dataItem.identification_number)}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    async function searchUsers(search) {
        const body = {
            "search": search,
            "order_fields": ["first_name", "last_name"],
            "order_type": "asc",
            "conditions": { "status": "ativo" }
        }
        Http.post(`/users/search-by`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setUserList(formatSelectData(responseData.data.data));
                }
            }).catch(err => {
                setUserList([]);                
            })
    }

    async function handleOnChangeUser(userId) {
        setEmailList([]);
        setPartnerList([]);
        setLoading(true);

        Http.get(`/users/get-user-emails-partners?id=${userId}`, Http.headers)
            .then(response => {
                const responseData = response.data    
                if (!responseData.response.error) {
                    dispatch(setSelectedUser(responseData.data));

                    let emails = responseData.data.emails;
                    emails.map((email) => { setEmailList(listEmails => [...listEmails, email.email]) })
                    
                    let partners = responseData.data.partners;
                    partners.map((partner) => { setPartnerList(listPartners => [...listPartners, partner.trading_name]) })
                }
                setLoading(false);
            }).catch(err => {
                setLoading(false);
                Message.showError(err.response.data.response.message);
            })
    }

    function handleOnSearchUser(e) {
        searchUsers(e);
    }

    function renderDataUser() {
        return (
            selectedUser.id ?
                !loading ?
                    <>
                        <Row gutter={20} style={{
                            borderBottom: "1px solid #eceef1",
                            paddingBottom: 16,
                            marginTop: 16,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Col span={2}>
                                <span className={"account-card-label"}>Nome:</span>
                            </Col>
                            <Col span={18}>
                                <span className={"account-card-data"}>{selectedUser.name}</span>
                            </Col>
                            <Col span={4}>

                            </Col>
                        </Row>

                        <Row gutter={20} style={{
                            borderBottom: "1px solid #eceef1",
                            paddingBottom: 16,
                            marginTop: 16,
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <Col span={2}>
                                <span className={"account-card-label"}>CPF:</span>
                            </Col>
                            <Col span={18}>
                                <span className={"account-card-data"}>{Utils.maskCpf(selectedUser.identification_number)}</span>
                            </Col>
                            <Col span={4}>

                            </Col>
                        </Row>

                        <DataFieldList
                            name={"emails"}
                            label={"E-mail(s):"}
                            list={emailList} />

                        <DataFieldList
                            noBorder={true}
                            name={"partners"}
                            label={"Parceiro(s):"}
                            list={PartnerList}
                            helpText={"Parceiros em que o usuário possui alguma permissão"}/>
                    </>
                    : <LoadingDataUser><Loading width={50} height={50} /></LoadingDataUser>
                : null
        )
    }

    return (
        <CardContainer style={{ minHeight: 328 }}>
            <Row gutter={20} style={{
                borderBottom: selectedUser.id ? "1px solid #eceef1" : "unset",
                paddingBottom: 16,
                marginTop: 16,
                display: "flex",
                alignItems: "center"
            }}>
                <Col span={2}>
                    <span className={"account-card-label"}>Usuário:</span>
                </Col>
                <Col span={18}>
                    <AccountSelect
                        value={selectedUser.name}
                        labelText="Nome, e-mail ou CPF"
                        style={{width: 300}}
                        list={userList}
                        onSearch={handleOnSearchUser}
                        onChange={handleOnChangeUser} />
                </Col>
                <Col span={4}>

                </Col>
            </Row>

            {renderDataUser()}
        </CardContainer>
    )
}

export default DataSearch;
